module.exports = __webpack_public_path__ + "static/scenario3-1fc2e7dbdd8b3f7ff4586e81e4cd9ace.png";